import localeText from './localeText';
import translate from '../../common/localization/translate';

function getMessage(message) {
  if (message === undefined) {
    return localeText().noRowsToShow;
  }
  return translate(message);
}

function getTemplate(overwrittenMessage) {
  return `<span class="ag-no-rows w-100 p-1 mx-auto mt-0">${getMessage(overwrittenMessage)}</span>`;
}

const AgGridOverlayNoRows = {
  getTemplate,
};

export default AgGridOverlayNoRows;
